// Full-bleed frame showing Dash's on-screen UI. The SVG lives at
// /public/assets/packshot.svg so Vite serves it directly, no bundling.
export default function PackshotGallery() {
  return (
    <section className="v3-gallery">
      <div className="v3-gallery-frame">
        <img
          src="/assets/packshot.svg"
          alt="Dash on-screen UI showing a live call in progress"
          loading="lazy"
        />
      </div>
    </section>
  );
}
